import { useSelector } from 'hooks/useSelector';
import * as React from 'react';
import { useDispatch } from 'react-redux';
import { Item } from 'screens/AssetsScreen/AssetList/Item/Item';
import { TOGGLE_CHOSEN_ASSET } from 'store/actions';
import {
  selectAssetListItem,
  selectIsAssetChosen,
} from 'store/assets/selectors';
import { selectAssetHasChanges } from 'store/changes/selectors';
import { selectOrganisationListItem } from 'store/organisations/selectors';

type Props = {
  id: string;
  handleItemPress: (id: string) => void;
};

export const ListItem: React.FC<Props> = ({ id, handleItemPress }) => {
  const dispatch = useDispatch();

  const asset = useSelector((state) => selectAssetListItem(state, id));
  const organisation = useSelector(
    (state) =>
      asset && selectOrganisationListItem(state, asset.organisation_id),
  );
  const selected = useSelector((state) => selectIsAssetChosen(state, id));
  const hasChanges = useSelector((state) => selectAssetHasChanges(state, id));

  const toggleChosen = React.useCallback(
    () => dispatch(TOGGLE_CHOSEN_ASSET(id)),
    [dispatch, id],
  );

  if (!asset || !organisation) return null;

  return (
    <Item
      asset={asset}
      selected={selected}
      organisation={organisation}
      onPress={() => handleItemPress(id)}
      onPressThumbnail={toggleChosen}
      hasChanges={hasChanges}
      useLocalThumbnail
    />
  );
};
